import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "Exit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Final = _resolveComponent("Final")!

  return (_openBlock(), _createBlock(_component_Final, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "lnr-earth GeoIcon" }, null, -1 /* CACHED */)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "MainHeading" }, " Do you want to quit? ", -1 /* CACHED */)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "SubHeading" }, " If you choose to do so, you will lose your progress. ", -1 /* CACHED */)),
        _createElementVNode("button", {
          class: "GeoHelperButton",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", null, "Continue to manage geotargeting", -1 /* CACHED */)
        ]))]),
        _createElementVNode("button", {
          class: "GeoHelperButton LowPriority",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeApp()))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", null, "Quit", -1 /* CACHED */)
        ]))])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}